import { ticketInfoTypes } from "components/dashboard/AgentInbox/enum";
import ErrorView from "components/ui/ErrorView/ErrorView";
import ShinyLoader from "components/ui/ShinyLoader/ShinyLoader";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiRoute } from "services";
import API from "services/lib/api";
import { saveCapsuleClassess } from "store/capsule/actions";
import { dataQueryStatus } from "utils";
import { getErrorMessage, isRequestCanceled } from "utils/helper";
import TicketsInfoElements from "./TicketsInfoElements/TicketsInfoElements";
import { saveTicketsInfoFilters } from "store/ticketsFilters/actions";
import { useSocket } from "services/socket/hook";
import { CLOSED_TICKET, NEW_TICKET_UPDATE } from "services/socket/events";

const { LOADING, DATAMODE, NULLMODE, ERROR, IDLE } = dataQueryStatus;
const { FORM, CAPSULE } = ticketInfoTypes;

const TicketsInfoFilter = ({
    filters,
    selectedTicketInfo,
    handleTicketInfoSelect,
    refreshData,
    showingFilters,
}) => {
    const socket = useSocket(); // Add socket hook
    const [retryCount, updateRetryCount] = useState(0);
    const [errorMssg, setErrorMssg] = useState("");
    const { capsuleClasses } = useSelector((state) => state.capsule);
    const { authTicketInfo } = useSelector((state) => state.ticketsFilters);
    const [status, setStatus] = useState(
        authTicketInfo?.length > 0 ? DATAMODE : IDLE
    );

    const dispatch = useDispatch();

    const { ticketsfilterRequest } = useSelector(
        (state) => state?.ticketsFilters
    );

    const { agentId, search, keywordSearch, ticketSource, dateFilterType, dateFrom, dateTo } = ticketsfilterRequest || {};

    const getCapsuleClasses = async (httpRequest) => {
        try {
            setErrorMssg();

            if (retryCount === 0 && capsuleClasses?.length < 1) {
                setStatus(LOADING);
                const url = apiRoute?.getCapsuleClasses;

                const res = await API.get(url, {
                    signal: httpRequest?.signal,
                });
                if (res.status === 200) {
                    const { data } = res.data;
                    dispatch(saveCapsuleClassess(data));
                    updateRetryCount(1);
                }
            }
            updateRetryCount(1);
        } catch (err) {
            if (isRequestCanceled(err, httpRequest)) {
                return;
            }
            setErrorMssg(getErrorMessage(err));
            setStatus(ERROR);
        }
    };

    const getAuthTicketInfo = async (httpRequest) => {
        try {
            console.log(`getAuthTicketInfo`);
            if (authTicketInfo?.length < 1) {
                setStatus(LOADING);
            }
            const url = apiRoute.getAgentTicketsInfoCount;

            if (!url) return;
            const res = await API.get(url, {
                signal: httpRequest?.signal,
                params: {
                    agentId,
                    search,
                    keywordSearch,
                    ticketSource,
                    dateFilterType,
                    dateFrom,
                    dateTo
                },
            });

            if (res.status === 200) {
                const { form, capsules } = res.data.data;
                // ticketInfoType, ticketInfoCapsuleClassId, ticketInfoValue, formName, count
                const formInfos = form.map(({ formName, formId }) => ({
                    ticketInfoType: FORM,
                    ticketInfoValue: formId,
                    formName,
                }));

                const capsulesInfos = capsules.map(
                    ({ capsuleClassId, classificationCapsuleEntryId }) => ({
                        ticketInfoType: CAPSULE,
                        ticketInfoCapsuleClassId: capsuleClassId,
                        ticketInfoValue: classificationCapsuleEntryId,
                    })
                );
                dispatch(
                    saveTicketsInfoFilters([...formInfos, ...capsulesInfos])
                );
                setStatus(DATAMODE);
            }
        } catch (err) {
            if (isRequestCanceled(err, httpRequest)) {
                return;
            }
            setErrorMssg(getErrorMessage(err));
            setStatus(ERROR);
        }
    };

    useEffect(() => {
        let httpRequest = new AbortController();

        console.log(`retryCount: ${retryCount}`);
        if (retryCount > 0) {
            getAuthTicketInfo(httpRequest);
        } else {
            getCapsuleClasses(httpRequest);
        }
        return () => {
            httpRequest.abort();
        };
        //eslint-disable-next-line
    }, [capsuleClasses, retryCount, refreshData, agentId, ticketSource, search, keywordSearch, dateFilterType, dateFrom, dateTo]);

    useEffect(() => {
        const handleTicketUpdate = () => {
            console.log(`Force refresh by incrementing retryCount`);
            updateRetryCount(prev => prev + 1);
        };

        socket?.on(NEW_TICKET_UPDATE, handleTicketUpdate);
        socket?.on(CLOSED_TICKET, handleTicketUpdate);

        return () => {
            socket?.off(CLOSED_TICKET, handleTicketUpdate);
            socket?.off(NEW_TICKET_UPDATE, handleTicketUpdate);
        };
    }, [socket]);


    const renderBasedOnStatus = () => {
        switch (status) {
            case LOADING:
                return <ShinyLoader width={`100%`} height={`100%`} />;

            case DATAMODE:
                return (
                    <TicketsInfoElements

                        {...{
                            filters,
                            selectedTicketInfo,
                            handleTicketInfoSelect,
                            authTicketInfo,
                            refreshData,
                        }}
                    />
                );

            case NULLMODE:
                return (
                    <div className='empty__text'>
                        <h6>No Tickets Info available</h6>
                    </div>
                );

            case IDLE:
                return (
                    <div className='empty__text'>
                        <h6>Tickets Infos show here</h6>
                    </div>
                );

            case ERROR:
                return <ErrorView message={errorMssg} />;

            default:
                return "";
        }
    };

    return (
        <div
            className={`${!showingFilters ? "" : "mt__filter--container"
                } custom-scroll-bar`}>
            {renderBasedOnStatus()}
        </div>
    );
};

export default TicketsInfoFilter;
